<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="text">The very first wireless communication device, of
course, was Mom. When I was an infant, she could hear
the faintest peep from the opposite end of the house. Now
that I’m an adult, she can hear the faintest peep from the
opposite end of town or, for that matter, the country.</p>
<div class="float_img_left_1-4_1"><img alt="" src="images/P-008-1.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom014.vue?7b1b0165